import React, { useContext, useEffect, useState } from 'react';
import { EmbedType } from  '@/interfaces/widgetPanel';
import { BuildPath } from  '@/helpers/Paths';
import { WebEmbedContext } from '@/context/WebEmbed';



const UseWebEmbedModal = (embedType: EmbedType, inputValue: string, embedId?: string) => {
    const {clearInputValues} = useContext(WebEmbedContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [disableUpload, setDisableUpload] = useState<boolean>(true);
    const [showPreview, setShowPreview] = useState<boolean>(false);
    const [inputPlaceholderText, setInputPlaceholderText] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (embedType){
            setPlaceholderText(embedType);
            setShowPreview(false);
        }
    }, [embedType])

    useEffect(() => {
        setShowPreview(false);

        if (inputValue && embedType === EmbedType.HTML){
            setDisableUpload(false);
        } else {
            setDisableUpload(true);
        }
    }, [inputValue])
    
    function onCheckContentClick() {
        setShowPreview(true);
        setIsLoading(true);
    }

    function onUploadClick() {
        switch (embedType) {
            case EmbedType.HTML:
                (window as any).functions.addHtmlWidget(inputValue);
                break;
            case EmbedType.YOUTUBE:
                (window as any).functions.addEmbedWidget('YouTube', embedId);
                break;
            case EmbedType.GIPHY:
                (window as any).functions.addEmbedWidget('Giphy', embedId);
                break;
            case EmbedType.GOOGLE_MAPS:
                (window as any).functions.addEmbedWidget('GoogleMaps', embedId);
                break;
            case EmbedType.VIMEO:
                (window as any).functions.addEmbedWidget('Vimeo', embedId);
                break;
        }

        clearInputValues();
    }

    function setPlaceholderText(embedType: EmbedType) {
        switch (embedType) {
            case EmbedType.YOUTUBE: 
                setInputPlaceholderText("Enter the YouTube video URL");
                break;
                
            case EmbedType.VIMEO: 
                setInputPlaceholderText("Enter the Vimeo video URL");
                break;
            
            case EmbedType.GOOGLE_MAPS: 
                setInputPlaceholderText("Enter the Google Maps HTML Embed code");
                break;
            
            case EmbedType.GIPHY: 
                setInputPlaceholderText("Enter the Giphy Embed code");
                break;

            case EmbedType.HTML:
            default:
                setInputPlaceholderText(undefined);
                break;
        }
    }

    function getDropdownIcon(embedType: EmbedType){
        switch (embedType) {
            case EmbedType.YOUTUBE:
                return `${BuildPath()}/images/htmlIcons/logo-youtube.svg`
                
            case EmbedType.VIMEO: 
                return `${BuildPath()}/images/htmlIcons/logo-vimeo.svg`
            
            case EmbedType.GOOGLE_MAPS: 
                return `${BuildPath()}/images/htmlIcons/logo-google-maps.svg`
            
            case EmbedType.GIPHY: 
                return  `${BuildPath()}/images/htmlIcons/logo-giphy.svg`   
            
            case EmbedType.HTML:
                return  `${BuildPath()}/images/htmlIcons/logo-code.svg`   

            default:
                return null
        }
    }

    function getDropdownIconAlt(embedType: EmbedType){
        switch (embedType) {
            case EmbedType.YOUTUBE:
                return `youtube play button`
                
            case EmbedType.VIMEO: 
                return `vimeo V`
            
            case EmbedType.GOOGLE_MAPS: 
                return `map pin`
            
            case EmbedType.GIPHY: 
                return  `giphy file`   
            
            case EmbedType.HTML:
                return  `code file`   

            default:
                return null
        }
    }

    return {isLoading, setIsLoading, onCheckContentClick, inputPlaceholderText, disableUpload, setDisableUpload, showPreview, getDropdownIcon, getDropdownIconAlt, onUploadClick};
};

export default UseWebEmbedModal;